import React from 'react';
import './checkBox.scss';


class CheckBox extends React.Component {

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }


  handleChange(event) {

    let { onChange } = this.props;
    let response = { value: event.target.checked };

    if (onChange) {
      onChange(response)
    }
  }


  render() {

    let { check, label, id } = this.props;
    let { handleChange } = this;

    let value = check || false;

    return (
      <div className="checkbox">
        <label>
          <input id={id} className="coloured-input" type="checkbox" checked={ value } onChange={ handleChange } />
          <span className="coloured-material checkbox-material">
            <span className="check">
            </span>
          </span> { label }
        </label>
      </div>
    );
  }
}

export default CheckBox;

